export function previousAvailableWeek(weekStart, minDate, maxDate, isAvailable) {
  const day = weekStart.clone().subtract(1, "day");
  while (day.isSameOrAfter(minDate, "day")) {
    if (!day.isAfter(maxDate, "day") && isAvailable(day)) {
      return day.clone().startOf("week");
    }
    day.subtract(1, "day");
  }
  return null;
}
